import useUiStore from "@/store/ui.state";
import { LangKey, useTranslation } from "@vixi/localization";
import { useState } from "react";
import { Button } from "./base/button";
import { Dialog, DialogContent, DialogTitle } from "./base/dialog";

export const ConfirmationDialog = () => {
  const { confirmDialog, hideConfirmDialog } = useUiStore();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    hideConfirmDialog();
    setLoading(true);
    await confirmDialog.onConfirm?.();
    setLoading(false);
  };

  const onOpenChange = async (open: boolean) => {
    if (!open) {
      hideConfirmDialog();
    }
  };

  return (
    <Dialog open={confirmDialog.show} onOpenChange={onOpenChange}>
      <DialogContent
        className={
          confirmDialog.dialogActions === null
            ? "!max-w-[676px] !h-[534px]  !border-2 !border-premium !p-0 !gap-0"
            : "max-w-90"
        }
        showCloseButton={confirmDialog.dialogActions !== null}
      >
        {confirmDialog.title && (
          <DialogTitle className="leading-[1.3]">{t(confirmDialog.title)}</DialogTitle>
        )}

        {confirmDialog.description &&
          (typeof confirmDialog.description === "string" ? (
            <p className="text-foreground-secondary fs-12">{confirmDialog.description}</p>
          ) : (
            confirmDialog.description
          ))}

        {confirmDialog.dialogActions ? (
          confirmDialog.dialogActions
        ) : confirmDialog.dialogActions === null ? null : (
          <div className="flex items-stretch">
            <ConfirmationDialogActions
              isLoading={loading}
              handleCancel={() => onOpenChange(false)}
              handleConfirm={handleConfirm}
              confirmText={confirmDialog.confirmText}
              cancelText={confirmDialog.cancelText}
            />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export interface ConfirmationDialogActionsProps {
  isLoading?: boolean;
  confirmText?: LangKey;
  cancelText?: LangKey;
  handleCancel: () => void;
  handleConfirm: () => void;
}

export const ConfirmationDialogActions = ({
  handleCancel,
  handleConfirm,
  confirmText,
  cancelText,
  isLoading,
}: ConfirmationDialogActionsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Button onClick={handleCancel} size="pill" variant="outlined" disabled={isLoading}>
        {t(cancelText ?? "No")}
      </Button>
      <Button
        onClick={handleConfirm}
        size="pill"
        color="destructive"
        variant="contained"
        disabled={isLoading}
      >
        {t(confirmText ?? "Yes")}
      </Button>
    </>
  );
};

export default ConfirmationDialog;
